module.exports = __webpack_public_path__ + "media/vid.471f7c7e.mp4";